// import React, { useState } from "react";
// import {
//   useStripe,
//   useElements,
//   PaymentElement,
// } from "@stripe/react-stripe-js";
// import Swal from "sweetalert2";

// const MonthlyCheckoutForm = ({ clientSecret, user, onClose }) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [isProcessing, setIsProcessing] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!stripe || !elements) return;

//     setIsProcessing(true);

//     const { error } = await stripe.confirmPayment({
//       elements,
//       confirmParams: {
//         return_url: window.location.href,
//         payment_method_data: {
//           billing_details: {
//             name: user?.name || "User",
//             email: user?.email || "",
//           },
//         },
//       },
//     });

//     // if (error) {
//     //   Swal.fire({
//     //     icon: "error",
//     //     title: "Payment Failed",
//     //     text: error.message,
//     //   });
//     if (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Payment Failed",
//         text: error.message,
//       }).then(() => {
//         if (onClose) onClose();
//       });
//     } else {
//       Swal.fire({
//         icon: "success",
//         title: "Payment Successful",
//         text: "Your subscription is now active!",
//         confirmButtonText: "Continue",
//       }).then(() => {
//         window.location.reload();
//       });
//     }

//     setIsProcessing(false);
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <PaymentElement />
//       <button type="submit" disabled={isProcessing || !stripe}>
//         {isProcessing ? "Processing..." : "PayNow"}
//       </button>
//     </form>
//   );
// };

// export default MonthlyCheckoutForm;

import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const MonthlyCheckoutForm = ({ clientSecret, user, onPaymentResult }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
      confirmParams: {
        payment_method_data: {
          billing_details: {
            name: user?.name || "User",
            email: user?.email || "",
          },
        },
      },
    });

    if (error) {
      onPaymentResult?.("error", error.message);
    } else if (paymentIntent?.status === "succeeded") {
      onPaymentResult?.("success", "Your subscription is now active!");
    } else {
      onPaymentResult?.("info", "Please check your payment status.");
    }

    setIsProcessing(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button type="submit" disabled={isProcessing || !stripe}>
        {isProcessing ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

export default MonthlyCheckoutForm;

// import React, { useState } from "react";
// import {
//   useStripe,
//   useElements,
//   PaymentElement,
// } from "@stripe/react-stripe-js";

// const MonthlyCheckoutForm = ({ clientSecret, user, onPaymentResult }) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [errorMessage, setErrorMessage] = useState(""); // <-- Stripe error

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!stripe || !elements) return;

//     setIsProcessing(true);
//     setErrorMessage("");
//     const { error, paymentIntent } = await stripe.confirmPayment({
//       elements,
//       redirect: "if_required",
//       confirmParams: {
//         payment_method_data: {
//           billing_details: {
//             name: user?.name || "User",
//             email: user?.email || "",
//           },
//         },
//       },
//     });

//     if (error) {
//       // show Stripe error inline
//       setErrorMessage(error.message || "Something went wrong.");
//     } else if (paymentIntent?.status === "succeeded") {
//       onPaymentResult?.("success", "Your subscription is now active!");
//     } else {
//       onPaymentResult?.("info", "Please check your payment status.");
//     }

//     setIsProcessing(false);
//   };

//   return (
//     <form onSubmit={handleSubmit} className="stripe-payment-form">
//       <PaymentElement />
//       {errorMessage && (
//         <div className="stripe-error-message">{errorMessage}</div>
//       )}

//       <button type="submit" disabled={isProcessing || !stripe}>
//         {isProcessing ? "Processing..." : "Pay Now"}
//       </button>
//     </form>
//   );
// };

// export default MonthlyCheckoutForm;
